import { ModuleProps, CreateModuleProps } from "components";
import { Rights } from "./Rights";

export const Module: ModuleProps = CreateModuleProps({
    id: "SETTINGS_SUBSCRIPTIONS",
    parentId: "SETTINGS_PARENT",
    applicationRights: Rights,
    title: 'Abonnement (kalender)',
    text: 'Abonnement (kalender)',
    icon: 'gear',
    showOnDashboardByDefault: false,
    url: "/settings/SUBSCRIPTIONS"
})
